export default class KeyNumbers {
    constructor() {
        this._items = Array.from(document.querySelectorAll('.kn__item'));
        this._items.forEach((item) => {
            item.querySelector('.kn__item__num .num').innerHTML = 0;
        });
    }
    render() {
        if (this._items.length) {
            window.addEventListener('scroll', this.doScroll.bind(this));
            this.doScroll();
        }
    }
    animateValue(obj, start, end, duration) {
        var range = end - start;
        // no timer shorter than 50ms (not really visible any way)
        var minTimer = 50;
        // calc step time to show all interediate values
        var stepTime = Math.abs(Math.floor(duration / range));
        // never go below minTimer
        stepTime = Math.max(stepTime, minTimer);
        // get current time and calculate desired end time
        var startTime = new Date().getTime();
        var endTime = startTime + duration;
        var timer;
        var isInt = end === parseInt(end, 10);
        function run() {
            var now = new Date().getTime();
            var remaining = Math.max((endTime - now) / duration, 0);
            var value = isInt ? Math.round(end - remaining * range) : Math.round((end - remaining * range) * 10) / 10;
            obj.innerHTML = value.toLocaleString('fr-FR');
            if (value == end) {
                clearInterval(timer);
            }
        }
        timer = setInterval(run, stepTime);
        run();
    }

    doScroll() {
        // check if element is visible
        this._items.forEach((item) => {
            const isInited = item.getAttribute('inited').toString() === 'true';
            if (!isInited) {
                const bounding = item.getBoundingClientRect();
                if (
                    bounding.top >= 0 &&
                    bounding.left >= 0 &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
                ) {
                    // item is in viewport, we can start animation
                    const num = item.querySelector('.kn__item__num .num');
                    const targetTo = parseFloat(num.getAttribute('data-target'));
                    item.setAttribute('inited', true);
                    this.animateValue(num, 0, targetTo, 2000);
                }
            }
        });
    }
}
